import React, { useEffect, useRef, useState } from "react";
import SAMPLE from "../data/sample.json";
import SAMPLE_PDF from "/home/tagrikli/Desktop/Yuki/display_page/src/data/P1_100716044_8cha_1.pdf";

import { Accordion, AccordionDetails, AccordionSummary, Container, Paper, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Dialog, Backdrop, IconButton, Switch, AlertColor, Collapse, Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { Document, Page } from "react-pdf";
import { filename2Path, normalizeHeader } from "../helpers/utils";
import { Stack } from "@mui/system";
import PDFViewer from "./PDFViewer";
import { KeyRounded, Margin } from "@mui/icons-material";
import HeaderFooter from "./HeaderFooter";
import { BASE, DATA_PATH, FTYPE } from "../helpers/consts";
import FieldHelper from "../helpers/FieldHelper";

function processHDU0(hdu0: any) {
    let hdu0_: any = {};

    const included = ["method", "mode", "filename", "trigtime", "trigutc"];

    Object.entries(hdu0).forEach((entry) => {
        const key: string = entry[0];
        const value = entry[1];

        if (included.includes(key.toLowerCase())) {
            if (key === "FILENAME") {
                hdu0_["FILENAME"] = (value as string).split(".")[0];
            } else {
                hdu0_[key] = value;
            }
        }
    });
    

    return hdu0_;
}

interface DisplayEventProps {
    onClose: any;
    filename: string | undefined;
    trigTime: string | undefined;
    trigUTC: string | undefined;
}

export default function DisplayEvent(props: DisplayEventProps) {
    const { onClose, filename, trigTime, trigUTC } = props;

    const [pdfPaths, setPdfPaths] = useState<string[]>([]);
    const [pdfPath, setPdfPath] = useState<string>('');
    const [pdfName, setPdfName] = useState<string>('');
    const [data, setData] = useState<any>(undefined);
    const [pdfIndex, setPdfIndex] = useState(0);
    const [bothExist, setBothExist] = useState(true);
    const [openSig, setOpenSig] = React.useState(false);
    const [openTrig, setOpenTrig] = React.useState(false);
    const [openFil, setOpenFil] = React.useState(false);
    const [deleteFiles, setDeleteFiles] = React.useState(false);
    const refAttr = useRef<string>('')
    const fh = new FieldHelper();
    

    const onPdfChange = (event: any, value: boolean) => {
        value ? 
        setPdfPath(`${BASE}/mysql_utils/file_reader.php?file_name=` + pdfName + '_8cha.pdf') : 
        setPdfPath(`${BASE}/mysql_utils/file_reader.php?file_name=` + pdfName + '_12det.pdf');
    };

    const processData = (data_json: any, filename: string, trigTime: any, trigUTC: any) => {
        let { HDU_1, HDU_2, HDU_3 } = data_json;
        
        let HDU1_ = JSON.parse(JSON.stringify(HDU_1));
        const {method: method, mode: mode} = getMethodModeFromFilename(filename)

        const time = new Date(Date.parse(HDU_2["TRIGUTC"]));

        const date = time.toLocaleDateString("en-US", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });

        const hour = time.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric",
        });

        // setData({ HDU0: HDU0_, HDU1: HDU1, HDU1_: HDU1_, HDU3: HDU3, time: time, date: date, hour: hour, method: method, mode: mode, sig: sig });
        setData({ HDU1: HDU_1, HDU1_: HDU1_, HDU3: HDU_3, metTime: trigTime, utcTime: trigUTC, method: method, mode: mode});
    };

    const getMethodModeFromFilename = (filename:string) => {
        const methods = {
            "B": "Bayesian",
            "P": "Poisson",
            "S": "SNR"
        }

        const modes = {
            "1": "Mode 1",
            "2": "Mode 2",
            "3": "Mode 3",
            "4": "Mode 4",
        }

        let firstChar: string = filename.at(0)!
        let secondChar: string = filename.at(1)!
        let fileMethod = methods[firstChar as keyof typeof methods]
        let fileMode = modes[secondChar as keyof typeof modes]

        return {method: fileMethod, mode: fileMode}
    }

    // const processPDF = (filename: string) => {
    //     console.log("pdf filename: ", filename)
    //     fetch(`${BASE}/mysql_utils/file_reader.php?file_name=` + filename
    //     ).then((res) => {
    //         if (res.status !== 200) {
    //             setBothExist(false);
    //             console.log(bothExist)
    //         }
    //     });
    // };

    useEffect(() => {
        if (filename !== undefined) {
            setDeleteFiles(false)
            const json_path = filename2Path(filename, FTYPE.JSON);
            const pdf_paths = filename2Path(filename, FTYPE.PDF) as string[];

            fetch(`${BASE}/mysql_utils/file_retriever.php`, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: "json_path=" + json_path + "&pdf_paths=" + pdf_paths.join(",") + "&file_name=" + filename,
            })
            .then((result) => result.text())
            .then((result) => {
                // setSearchResult(result.slice(1));
                // setOpen(false);
                // showResult && snack(`${result[0].count} events found.`, "info");
                // setCountResult(result[0].count);

                setPdfPaths(pdf_paths.map((path) => DATA_PATH + "/" + path));
                
                // Uncomment Or delete
                // processPDF(DATA_PATH + "/" + filename + '.pdf');
                const pdfRandomName = result.substring(4)
                setPdfPath(`${BASE}/mysql_utils/file_reader.php?file_name=` + pdfRandomName + '_12det.pdf')
                setPdfName(pdfRandomName)
                refAttr.current = pdfName
                // processPDF(DATA_PATH + "/" + pdf_paths[1]);
    
                fetch(`${BASE}/mysql_utils/${result}.json`, {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                })
                .then((resp) => {
                    
                    resp.json().then((data_json) => {
                        processData(data_json, filename, trigTime, trigUTC);
                    })
                })
                .catch((reason) => console.log(reason));
            })
            .catch((reason) => {
                console.log(reason);
            });

            return () => {
                setDeleteFiles(true)
            }
        } else {
            console.log("filename NOT OK");
        }
    }, [filename, trigTime, trigUTC]);
    useEffect(() => {
        if (deleteFiles)
            fetch(`${BASE}/mysql_utils/file_delete.php?file_name=` + pdfName, {
                method: "DELETE",
                headers: { "Content-Type": "ax-www-form-urlencoded" },
            })
    }, [deleteFiles])

    return (
        <Dialog open={filename !== undefined} onClose={onClose} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} fullWidth={true} maxWidth="xl">
            {props.filename === undefined ? (
                <div>No Filename</div>
            ) : data === undefined ? (
                <div>Loading...</div>
            ) : (
                <Box sx={{ width: "100%" }} height="90vh">
                    <Stack margin={0} padding={4} direction="row" justifyContent="space-between" alignItems="center">
                        <Typography fontSize={"x-large"} textAlign="center" margin={0}>
                            {data.method} - {data.mode} event on {data.utcTime} UTC
                        </Typography>
                        <IconButton onClick={() => onClose(undefined, "backdropClick")}>
                            <CloseIcon></CloseIcon>
                        </IconButton>
                    </Stack>

                    <Stack padding={{ md: 5 }} direction={{ md: "row" }} justifyContent="space-between" spacing={{ sm: 1, md: 6 }}>
                        <Box flex={{ md: 1 }}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Property</strong></TableCell>
                                            <TableCell align="right"><strong>Value</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Method
                                            </TableCell>
                                            <TableCell align="right">{data.method}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Mode
                                            </TableCell>
                                            <TableCell align="right">{data.mode}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Event Time (MET)
                                            </TableCell>
                                            <TableCell align="right">{data.metTime}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                Event Time (UTC)
                                            </TableCell>
                                            <TableCell align="right">{data.utcTime}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                            <TableCell component="th" scope="row">
                                                Classes
                                            </TableCell>
                                            <TableCell align="right">
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => setOpenSig(!openSig)}
                                            >
                                                {openSig ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                            <Collapse in={openSig} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                <Table size="small" aria-label="purchases">
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell>Category</TableCell>
                                                        <TableCell align="right">Probabilty</TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {data.HDU3.map((significanceArray: any) => (
                                                        <TableRow key={significanceArray[1]}>
                                                        <TableCell component="th" scope="row">
                                                            {significanceArray[1]}
                                                        </TableCell>
                                                        <TableCell align="right">{significanceArray[0].toFixed(3)}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    </TableBody>
                                                </Table>
                                                </Box>
                                            </Collapse>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                            <TableCell component="th" scope="row">
                                                Triggered Detectors
                                            </TableCell>
                                            <TableCell align="right">
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => setOpenTrig(!openTrig)}
                                            >
                                                {openTrig ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                            <Collapse in={openTrig} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                <Table size="small" aria-label="purchases">
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell>Detector Name</TableCell>
                                                        <TableCell align="right">Detection</TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {data.HDU1[0][7].map((element: number, index: number) => (
                                                        <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            Detector {index}
                                                        </TableCell>
                                                        <TableCell align="right">{element == 1 ? <strong>True</strong>: 'False'}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    </TableBody>
                                                </Table>
                                                </Box>
                                            </Collapse>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Burst Count (Epiv - 2000 keV) / Burst Count (10 - Epiv keV) at the peak of the event">
                                                    <span>
                                                        Hardness Ratio (Epiv=25keV)
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.HDU1[0][1].toFixed(3)}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Burst Count (Epiv - 2000 keV) / Burst Count (10 - Epiv keV) at the peak of the event">
                                                    <span>
                                                        Hardness Ratio (Epiv=50keV)
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.HDU1[0][2].toFixed(3)}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Burst Count (Epiv - 2000 keV) / Burst Count (10 - Epiv keV) at the peak of the event">
                                                    <span>
                                                        Hardness Ratio (Epiv=75keV)
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.HDU1[0][3].toFixed(3)}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                McIlwain L parameter, distance">
                                                    <span>
                                                        L-shell
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.HDU1[0][8].toFixed(3)}</TableCell>
                                        </TableRow>
                                        <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                             <TableCell component="th" scope="row">
                                                <Tooltip title="
                                                Count Rate (in the brightest detector) / Count Rate (in the dimmest detector) between 12 NaI detectors at the time of trigger">
                                                    <span>
                                                        Ratio
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="right">{data.HDU1[0][11].toFixed(3)}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                            <TableCell component="th" scope="row">
                                                Filtering Classes
                                            </TableCell>
                                            <TableCell align="right">
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => setOpenFil(!openFil)}
                                            >
                                                {openSig ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                            <Collapse in={openFil} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                <Table size="small" aria-label="purchases">
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell>Class</TableCell>
                                                        <TableCell align="right">Grade</TableCell>
                                                    </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {data.HDU1[0][4].map((element: string, index: number) => (
                                                        <TableRow key={element}>
                                                        <TableCell component="th" scope="row">
                                                            {element}
                                                        </TableCell>
                                                        <TableCell align="right">{data.HDU1[0][5][index]}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    </TableBody>
                                                </Table>
                                                </Box>
                                            </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Stack flex={{ md: 4 }} direction="column" justifyContent={"stretch"} minHeight="100vh">
                            {true ? (
                                <Stack direction={"row"} justifyContent="end" alignItems="center">
                                    <Typography>12Det</Typography>
                                    <Switch onChange={onPdfChange}></Switch>
                                    <Typography>8Cha</Typography>
                                </Stack>
                            ) : (
                                <div></div>
                            )}

                            <PDFViewer file={pdfPath}></PDFViewer>
                        </Stack>
                    </Stack>
                </Box>
            )}
        </Dialog>
    );
}
